import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import { Routes } from 'enums';
import _ from 'lodash';

import PaiCheckbox from 'features/ui/base-components/pai-checkbox';
import PaiLink from 'features/ui/base-components/pai-link';

import { Contact } from '../contact-management.types';

interface Props {
  contact: Contact;
  selected: boolean;
  handleSelect(): void;
}

const ContactItem: React.FC<Props> = ({ contact, selected, handleSelect }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const location = useLocation();

  let fullName = '';
  const { firstname, lastname } = contact;

  if (firstname) fullName += firstname;
  if (lastname) {
    if (firstname) fullName += ' ';
    fullName += lastname;
  }

  // Fallback name if both are missing
  const displayName = _.truncate(fullName, { length: 30 }) || t('linkedinUser');

  return (
    <TableRow
      role="checkbox"
      tabIndex={-1}
      key={contact._id}
    >
      <TableCell>
        <PaiCheckbox checked={selected} disableUncheckedColor={true} padding={'4px'} onChange={handleSelect} />
      </TableCell>

      <TableCell>
        <Link
          className={classes.link}
          to={`${Routes.CONTACT_MANAGEMENT_CONTACT}/${contact._id}`}
          state={{ from: location.pathname, query: location.search }}
        >
          <PaiLink text={displayName} variant={'primary'} size={'md'} />
        </Link>
      </TableCell>

      <TableCell>{contact.occupation || '-'}</TableCell>

      <TableCell>
        {contact.profileId ? (
          <PaiLink
            text={contact.profileId}
            variant={'primary'}
            size={'md'}
            href={contact.profileId}
            target={'_blank'}
          />
        ) : (
          '-'
        )}
      </TableCell>

      <TableCell>
        {!_.isNil(contact.contactDegree)
          ? contact.contactDegree === 1
            ? t('yes')
            : t('no')
          : '-'}
      </TableCell>

      <TableCell>{contact.companyName || '-'}</TableCell>
      <TableCell>{contact.email || '-'}</TableCell>
    </TableRow>
  );
};

const useStyles = makeStyles()((theme) => ({
  link: {
    textDecoration: 'none'
  },
  disabled: {
    opacity: 0.4
  },
  loading: {
    pointerEvents: 'none',
    background: theme.palette.action.hover
  },
  notAvailableText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.light
  }
}));

export default ContactItem;
